<script lang="ts" setup>
import type { IconProps } from '@nuxt/ui';
import { tv } from 'tailwind-variants';
import { computed } from 'vue';
import ImageComponent from '#build/ui-image-component';
import { isUrl } from '#layers/ui/utils/url';

const { icon, ui: uiProp } = defineProps<{
	icon: IconProps['name'];
	ui?: Partial<typeof iconOrImage['slots']>;
}>();

const iconOrImage = tv({
	slots: {
		image: '',
		icon: '',
	},
});

const ui = iconOrImage();

const isImage = computed(() => typeof icon === 'string' ? isUrl(icon) : false);
</script>

<template>
	<ImageComponent
		v-if="isImage"
		:src="icon as string"
		:alt="icon as string"
		:class="ui.image({ class: uiProp?.image })"
	/>
	<DIcon
		v-else
		:name="icon"
		:class="ui.icon({ class: uiProp?.icon })"
	/>
</template>
